import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, inject, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { Helper } from "src/app/core/helpers/helper";
import { CountryPhonecodeComponent } from "../modal-components/country-phonecode/country-phonecode.component";
import { debounceTime, distinctUntilChanged, Observable, of, Subject, Subscription, switchMap } from "rxjs";
import { GoogleMapsService } from "../services/google-map.service";
import { MapBoxService } from "../services/mapbox.service";
import { CountryService } from "../services/country.service";
import { BookingService } from "../services/booking.service";
import { ViewFareEstimateModalComponent } from "../modal-components/view-fare-estimate-modal/view-fare-estimate-modal.component";
import { FixFareTripModalComponent } from "../modal-components/fix-fare-trip-modal/fix-fare-trip-modal.component";
import { SurgePriceModalComponent } from "../modal-components/surge-price-modal/surge-price-modal.component";
import { BookingVehicleFilterModalComponent } from "../modal-components/booking-vehicle-filter-modal/booking-vehicle-filter-modal.component";
import { AdminService } from "../services/admin.service";
import { UsersService } from "../services/users.service";
import { CommonService } from "../services/common.service";
import { PaymentMode } from "src/app/core/constants/constants";
import { BookingType, BusinessType } from "src/app/core/constants/bookingConstant";
import { DateTimePickerModalComponent } from "../modal-components/date-time-picker-modal/date-time-picker-modal.component";
import { DatePipe } from "@angular/common";
import { ToasterService } from "../services/toaster.service";
import { buildBookRideAddress, buildCreateRidePayload } from "./create-ride-payload";

@Component({
  selector: "app-booking-ride",
  templateUrl: "./booking-ride.component.html",
  styleUrl: "./booking-ride.component.scss",
  standalone: false
})
export class BookingRideComponent implements OnInit, AfterViewInit, OnDestroy {
  DownCollapsed: boolean = false;
  isGoogle: boolean = false;
  userForm!: FormGroup;
  rideDetailsForm!: FormGroup;
  selectedBookingType: any;

  private inputSubject: Subject<any> = new Subject<any>();
  private inputSubscription!: Subscription;
  updateObservable!: Subscription;

  predictions: any = [];
  destinationPredictions: any = [];
  stopPrediction: any = [];
  stopAddresses: any = [];
  mapBoxSuggestions: Array<any> = [];
  mapBoxSuggestionsForStop: Array<any> = [];
  mapBoxSuggestionsForDestination: Array<any> = [];
  DispatcherBookingType: any = [];
  DispatcherBookingTypeTime: any = [];
  vehicleCapacityList: Array<any> = [];
  agencies: Array<any> = [];

  surgeUnit: any = null;
  selectedPlace: any;
  countryList: any;
  selectedCountry: any;
  autoComplateElement: any;
  vehicleTypesData: any;
  vehicleTypeList: any;
  selectedVehicleType: any;
  nearestProvider: any;
  customerDetails: any;
  /** Rider the current vehicle list was priced for (see getVehicleTypeList / createRide). */
  private quotedForCustomerId: string = "";
  selectedRentalPackage: any;
  countrySetting: any;
  bookingSetting: any;
  appliedfilterDetails: any;

  selectedMapBoxSearchIndex: number = -1;
  maxStopLimit: number = 5;
  addedStopNumber!: number;
  currentStep: number = 1;
  /** Call-taking stays on one screen. The wizard steps still validate in order. */
  oneScreen = true;

  cityAddress: string = "";
  driverId!: string;
  selectedSearchAddress!: string;
  customerNote!: string;

  minScheduleDate: Date = new Date();
  isManually: number = this.helper.bookingDriverAssignEnum.NEAREST_DRIVER;
  daysFromToday: number = this.helper.maxScheduleBookingDaysFromToday;
  bufferTime: number = 0;

  isUserFilled: boolean = false;
  isTypeDetailsCalled: boolean = false;
  public BlockCollapsed = false;
  public BlockCollapsedTwo = false;
  public BlockCollapsedThree = false;
  isSurgePriceAvailable: boolean = false;
  isFixFareAvailable: boolean = false;
  isAlwaysFixFare: boolean = false;
  isMultipleLocations: boolean = false;
  isAllowOutsideBoundry: boolean = false;
  isAgencyError: boolean = false;
  isShowAgencySelection: boolean = false;

  fetchDistance: number = 0;
  fetchTime: number = 0;
  fetchdirectionPath: string | null = null;
  uniqueDrivers: Array<any> = [];
  userData: any;
  selectedPaymentMethod: number = this.helper.PaymentMode.Cash;
  selectedAgencyId: string | null = null;
  totalEstimatedFare: number = 0;
  totalAccessibilityPrices: number = 0;
  bookingTime!: any;

  questionsList: Array<any> = [];
  currentQuestionIndex: number = 0;
  isShowQuestionsModal: boolean = false;
  pendingBookingId: string = '';
  String = String;
  BusinessType = BusinessType;
  pendingIsFixFare: boolean = false;
  pendingUpdatedCharges: any[] = [];

  @Input() totalRideDistance: number = 0;
  @Input() totalRideTime: number = 0;
  @Input() directionPath!: string;
  @Input() selectedBusinessType: number = BusinessType.TAXI;

  @Output() setMarker = new EventEmitter();
  @Output() removeMarker = new EventEmitter();
  @Output() setMapPath = new EventEmitter<{ fetchDistance: any; fetchTime: any; fetchdirectionPath: any }>();
  @Output() completeBooking = new EventEmitter();
  @Output() setNearestDriver = new EventEmitter();
  @Output() onGetVehicleTypeList = new EventEmitter();
  @Output() onSelectVehicleType = new EventEmitter();

  @ViewChild("countryCodeModal", { static: true }) countryCodeModal!: CountryPhonecodeComponent;
  @ViewChild("viewFareEstimate", { static: true }) viewFareEstimate!: ViewFareEstimateModalComponent;
  @ViewChild("fixFareModal", { static: true }) fixFareModal!: FixFareTripModalComponent;
  @ViewChild("surgePrice", { static: true }) surgePrice!: SurgePriceModalComponent;
  @ViewChild("bookingVehicleFilterModal", { static: true }) bookingVehicleFilterModal!: BookingVehicleFilterModalComponent;
  @ViewChild("dateTimePickerModal", { static: true }) dateTimePickerModal!: DateTimePickerModalComponent;

  private readonly toasterService = inject(ToasterService);


  // eslint-disable-next-line max-params
  constructor(
    public helper: Helper,
    private fb: FormBuilder,
    private googleMapService: GoogleMapsService,
    private mapBoxService: MapBoxService,
    private countryService: CountryService,
    private bookingService: BookingService,
    private _cdr: ChangeDetectorRef,
    private adminService: AdminService,
    private userService: UsersService,
    private commonService: CommonService,
    private datePipe: DatePipe
  ) {
    // Forms exist before the first change detection. Caller lookup reads
    // `controls` while the view is binding; a null FormGroup throws
    // "Cannot read properties of null (reading 'controls')".
    this._initForm();
  }

  /**
   * Initializes the component with necessary setup.
   * Fetches the list of countries and initializes the form with default values.
   * Sets the initial booking type based on dispatcher booking types.
   *
   * @param {void}
   * @returns {void}
   */
  ngOnInit(): void {
    this.isGoogle = this.helper.mapTypeGoogle();
    this.updateObservable = this.userService.updateObservable.subscribe((res) => {
      if (res) {
        this.fetchData(true);
      } else {
        this.fetchData();
      }
    });
    this.getCountryList();
    if (this.selectedBusinessType === BusinessType.TOWING) {
      this.getQuestionsList();
    }
  }

  /**
   * Performs actions after the view has been initialized.
   * Sets a timeout to calculate scrollable height if window width is greater than 991px.
   * Listens to window resize events to adjust scrollable height or reset it based on window width.
   *
   * @param {void}
   * @returns {void}
   */
  ngAfterViewInit(): void {
    setTimeout(() => {
      if (window.innerWidth > 991) {
        this.helper.calculateScorallableHeight();
      }
    }, 500);
    window.addEventListener("resize", ($event: any) => {
      if ($event.target.innerWidth > 991) {
        this.helper.calculateScorallableHeight();
      } else {
        const tableCustomScroll2 = document.querySelector(".custom-scroll-height-2") as HTMLElement;
        tableCustomScroll2.style.height = "auto";
      }
    });
  }

  /**
   * Handles keyboard events for address prediction selection based on the active autocomplete element.
   * Listens for ArrowDown, ArrowUp, and Enter keys to navigate and select predictions.
   *
   * @param event The keyboard event object.
   * @returns {void}
   */
  @HostListener("document:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent): void {
    const mapType = this.helper.dispatcherDetails.setting.mapType;
    const isGoogleMap = mapType === this.helper.MapType.GOOGLE;

    const predictions = this.getPredictions(this.autoComplateElement, isGoogleMap);
    if (predictions && predictions.length > 0) {
      this.handleKeyEvent(event.key, predictions, isGoogleMap);
    }
  }

  /**
   * Retrieves predictions based on the active autocomplete element.
   *
   * @param element The active autocomplete element.
   * @param isGoogleMap Indicates whether the predictions are for Google Maps or MapBox.
   * @returns {any} The predictions array.
   */
  getPredictions(element: string, isGoogleMap: boolean): any {
    switch (element) {
      case this.helper.AddressType.PICKUP:
        return isGoogleMap ? this.predictions : this.mapBoxSuggestions;
      case this.helper.AddressType.STOP:
        return isGoogleMap ? this.stopPrediction : this.mapBoxSuggestionsForStop;
      default:
        return isGoogleMap ? this.destinationPredictions : this.mapBoxSuggestionsForDestination;
    }
  }

  /**
   * Fetches the user data from the admin service.
   * If the profile is updated, it fetches the city list based on the country ID.
   *
   * @param {boolean} isProfileUpdated - Indicates whether the profile has been updated.
   * @returns {void}
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private fetchData(isProfileUpdated: boolean = false): void {
    this.adminService.getDetails({ isShowSuccessToast: false }).subscribe((res: any) => {
      this.userData = res.entity;
    });
  }

  /**
   * Handles key events for navigating and selecting predictions.
   *
   * @param key The key pressed.
   * @param predictions The array of predictions.
   * @param isGoogleMap Indicates whether the predictions are for Google Maps or MapBox.
   * @returns {void}
   */
  handleKeyEvent(key: string, predictions: any[], isGoogleMap: boolean): any {
    switch (key) {
      case "ArrowDown":
        this.updateSelectedIndex(predictions.length, 1);
        break;
      case "ArrowUp":
        this.updateSelectedIndex(predictions.length, -1);
        break;
      case "Enter":
        this.selectPrediction(predictions, isGoogleMap);
        break;
      default:
        this.selectPrediction(predictions, isGoogleMap);
    }
  }

  /**
   * Updates the selected index for predictions navigation.
   *
   * @param length The length of the predictions array.
   * @param step The step to update the index.
   * @returns {void}
   */
  private updateSelectedIndex(length: number, step: number): void {
    this.selectedMapBoxSearchIndex = (this.selectedMapBoxSearchIndex + step + length) % length;
  }

  /**
   * Selects a prediction from the provided predictions array based on the current selected index.
   *
   * @param predictions The array of predictions to select from.
   * @param isGoogleMap Indicates whether the predictions are for Google Maps or MapBox.
   * @returns {void}
   */
  private selectPrediction(predictions: any[], isGoogleMap: boolean): void {
    if (this.selectedMapBoxSearchIndex >= 0 && this.selectedMapBoxSearchIndex < predictions.length) {
      if (isGoogleMap) {
        this.onPredictionSelect(predictions[this.selectedMapBoxSearchIndex]);
      } else {
        this.onSelect(predictions[this.selectedMapBoxSearchIndex]);
      }
      this.selectedMapBoxSearchIndex = -1;
    }
  }

  /**
   * Handles changes in input properties.
   *
   * @param changes The changes in input properties.
   * @returns {void}
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["totalRideDistance"]?.currentValue || changes["totalRideTime"]?.currentValue || changes["directionPath"]?.currentValue) {
      this.getVehicleTypeList();
    }
  }

  /**
   * Clears the user form and resets customer details.
   *
   * @param {void}
   * @returns {void}
   */
  clearUserForm(): void {
    this.userForm.reset();
    this.customerDetails = null;
    this.userForm.patchValue({
      countryPhoneCode: this.selectedCountry[0].phoneCodes[0]
    });
  }

  /**
   * Custom form validator to validate addresses in the rideDetailsForm.
   * Ensures that the pickup, drop-off, and stop addresses are unique and valid.
   *
   * @param {void}
   * @returns {ValidatorFn} The validation function to be used for the form group.
   */
  commonValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!(control instanceof FormGroup)) {
        return null;
      }

      const formGroup = control;
      const pickupAddress = formGroup.get("pickupAddress")?.value;
      const dropOffAddress = formGroup.get("dropOffAddress")?.value;
      const stops = formGroup.get("stops") as FormArray | null;
      if (!stops?.controls) return null;

      // Reset all control errors
      formGroup.get("pickupAddress")?.setErrors(null);
      formGroup.get("dropOffAddress")?.setErrors(null);
      stops.controls.forEach((stop) => stop.get("stopAddress")?.setErrors(null));

      if (!pickupAddress || !dropOffAddress) {
        return null;
      }

      // Drop-off validation
      if (stops.length === 0) {
        if (pickupAddress.placeId === dropOffAddress.placeId) {
          formGroup.get("dropOffAddress")?.setErrors({ sameLocation: true });
        }
      } else {
        const lastStopAddress = stops.at(stops.length - 1).get("stopAddress")?.value;
        if (lastStopAddress?.placeId === dropOffAddress?.placeId) {
          formGroup.get("dropOffAddress")?.setErrors({ duplicateAddress: true });
        }
      }

      // Unique stop address validation
      stops.controls.forEach((stopControl: AbstractControl, index: number) => {
        const currentStopAddress = stopControl.get("stopAddress")?.value;

        if (index === 0 && pickupAddress?.placeId === currentStopAddress?.placeId) {
          stopControl.get("stopAddress")?.setErrors({ duplicateAddress: true });
        }

        if (index === stops.length - 1 && dropOffAddress?.placeId === currentStopAddress?.placeId) {
          stopControl.get("dropOffAddress")?.setErrors({ duplicateAddress: true });
        }

        if (index > 0) {
          const previousStopAddress = stops.at(index - 1).get("stopAddress")?.value;
          if (previousStopAddress?.placeId === currentStopAddress?.placeId) {
            stopControl.get("stopAddress")?.setErrors({ duplicateAddress: true });
          }
        }

        if (index < stops.length - 1) {
          const nextStopAddress = stops.at(index + 1).get("stopAddress")?.value;
          if (nextStopAddress?.placeId === currentStopAddress?.placeId) {
            stops
              .at(index + 1)
              .get("stopAddress")
              ?.setErrors({ duplicateAddress: true });
          }
        }
      });

      return null;
    };
  }

  /**
   * Handles the progression of steps in the multi-step form process.
   * Validates the form and updates the UI accordingly based on the current step.
   *
   * @param {number} step The current step in the form process.
   * @returns {void}
   */
  continue(step: number): void {
    let isInvalidForm = false;

    switch (step) {
      case 1:
        if (this.userForm.invalid) {
          isInvalidForm = true;
          this.userForm.markAllAsTouched();
        } else {
          this.isUserFilled = true;
          this.BlockCollapsed = true;
          this.BlockCollapsedTwo = false;
          this.currentStep = 2;
        }
        break;

      case 2:
      case 3:
        if (this.rideDetailsForm.invalid) {
          isInvalidForm = true;
          this.rideDetailsForm.markAllAsTouched();
        } else if (step === 2) {
          if (this.DispatcherBookingType.length === 0) {
            return;
          }
          this.resetPrediction();
          this.rideDetailsForm.patchValue({
            pickup: this.rideDetailsForm.value.pickupAddress.address,
            dropOff: this.rideDetailsForm.value.dropOffAddress.address
          });

          if (this.isAllowOutsideBoundry) {
            this.setMapPath.emit({ fetchdirectionPath: this.fetchdirectionPath, fetchDistance: this.fetchDistance, fetchTime: this.fetchTime });
            this.currentStep = 3;
            this.validatorUpdateOnStop();
          }
        } else if (step === 3) {
          this.BlockCollapsedTwo = true;
          this.getNearestProvider();
          // if(){
          this.getAgencies();
          // }
          this.currentStep = 4;
        }
        break;
      default:
    }

    if (isInvalidForm) return;
  }

  /** Walks the wizard in order, then books. Stops on the first invalid step. */
  bookFromOneScreen(): void {
    if (this.currentStep < 2) this.continue(1);
    if (this.currentStep === 2) this.continue(2);
    if (this.currentStep === 3) this.continue(3);
    if (this.currentStep === 4) this.onFixFare();
  }

  /**
   * Navigates to the previous step in the multi-step form process.
   * Performs necessary cleanup and resets relevant fields based on the current step.
   *
   * @param {number} step The current step to navigate back from.
   * @returns {void}
   */
  goToPrevious(step: number): void {
    if (step === 2) {
      this.currentStep = 1;
      this.resetPrediction();
      this.BlockCollapsed = false;
      this.DispatcherBookingType = [];
      this.isMultipleLocations = false;
      this.rideDetailsForm.reset();
      this.clearAddress(this.helper.AddressType.PICKUP);
      this.clearAddress(this.helper.AddressType.DESTINATION);
      const stopsArray = this.stops;
      // Loop through all stops in reverse order
      for (let i = stopsArray.length - 1; i >= 0; i--) {
        this.removeMarker.emit(i); // Emit the removeMarker event for each stop in decreasing order
      }

      this.stops.clear();
    } else if (step === 3) {
      this.currentStep = 2;
      this.validatorUpdateOnStop();
      this.appliedfilterDetails = null;
      this.setupBookingTypeVehicleList();
    } else if (step === 4) {
      this.currentStep = 3;
      this.BlockCollapsedTwo = false;
    }
  }

  /**
   * Handles address editing and navigates to the previous step if necessary.
   *
   * @param currentStep The current step in the form process.
   * @returns {void}
   */
  onAddressEdit(currentStep: any): void {
    if (currentStep === 3) {
      this.goToPrevious(currentStep);
    }
  }

  /**
   * Updates the form validators based on the current step and booking type.
   * Adds or removes validators for form controls based on the current step and booking type.
   *
   * @param {void}
   * @returns {void}
   */
  validatorUpdateOnStop(): void {
    const setValidators = (controlName: string, validators: any[]): void => {
      this.rideDetailsForm.get(controlName)?.setValidators(validators);
      this.rideDetailsForm.get(controlName)?.updateValueAndValidity();
    };

    const isRental = this.rideDetailsForm.value.bookingType === BookingType.RENTAL;

    if (this.currentStep === 3) {
      setValidators("vehicleType", [Validators.required]);

      if (isRental) {
        setValidators("rentalPackage", [Validators.required]);
      }
    } else {
      setValidators("vehicleType", []);

      if (isRental) {
        setValidators("rentalPackage", []);
      }
    }
  }

  /**
   * Navigates to a specific step in the multi-step form process.
   *
   * @param step The step to navigate to.
   * @returns {void}
   */
  goToStep(step: any): void {
    this.currentStep = step;
    this.validatorUpdateOnStop();
  }

  /**
   * Initializes and configures the userForm and rideDetailsForm using Angular Reactive Forms.
   * Configures userForm for user information and rideDetailsForm for ride details.
   * Subscribes to changes in the 'when' control of rideDetailsForm to dynamically update validators.
   *
   * @param {void}
   * @returns {void}
   */
  _initForm(): void {
    this._initUserForm();
    this._initRideDetailsForm();
    this._setupRideDetailsFormSubscriptions();
  }

  private _initUserForm(): void {
    this.userForm = this.fb.group({
      phone: ["", [Validators.required, Validators.minLength(this.helper.minPhoneNumberLength)]],
      countryPhoneCode: ["", [Validators.required]],
      firstName: ["", [Validators.required, Validators.maxLength(this.helper.NameMaxLength * 2 + 1), this.helper.nameValidator()]],
      email: ["", [Validators.pattern(this.helper.emailRegex)]]
    });
  }

  private _initRideDetailsForm(): void {
    const whenInitValue = this.setWhenBookingString();
    this.rideDetailsForm = this.fb.group(
      {
        pickup: ["", [Validators.required]],
        pickupAddress: [""],
        dropOff: ["", [Validators.required]],
        dropOffAddress: [""],
        when: [whenInitValue, Validators.required],
        scheduleDate: [""],
        scheduleTime: [""],
        stops: this.fb.array([]),
        vehicleType: [null],
        rentalPackage: [null],
        bookingType: [null],
        paymentMethod: [this.selectedPaymentMethod, [Validators.required]]
      },
      { validators: this.commonValidator() }
    );
  }

  private _setupRideDetailsFormSubscriptions(): void {
    this.rideDetailsForm.get("pickup")?.valueChanges.subscribe(() => {
      this.rideDetailsForm.get("dropOff")?.updateValueAndValidity();
    });
  }

  /**
   * Retrieves the controls of the userForm.
   *
   * @param {void}
   * @returns { { [key: string]: AbstractControl } } The controls of the userForm.
   */
  get controls(): { [key: string]: AbstractControl } {
    return this.userForm?.controls || {};
  }

  /**
   * Retrieves the controls of the rideDetailsForm.
   *
   * @param {void}
   * @returns { { [key: string]: AbstractControl } } The controls of the rideDetailsForm.
   */
  get addressControls(): { [key: string]: AbstractControl } {
    return this.rideDetailsForm?.controls || {};
  }

  /**
   * Retrieves the stops array from the rideDetailsForm.
   *
   * @param {void}
   * @returns {FormArray} The stops array.
   */
  get stops(): FormArray {
    const stops = this.rideDetailsForm?.get("stops") as FormArray | null;
    return stops?.controls ? stops : this.fb.array([]);
  }

  /**
   * Retrieves the maximum schedule date based on the days from today.
   *
   * @param {void}
   * @returns {string} The maximum schedule date.
   */
  get maxScheduleDate(): string {
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + this.daysFromToday);
    return maxDate.toISOString().split("T")[0];
  }

  /**
   * Retrieves the minimum date with buffer time.
   *
   * @param {void}
   * @returns {Date} The minimum date with buffer time.
   */
  get minDateWithBufferTime(): Date {
    return new Date(this.minScheduleDate.getTime() + this.bufferTime * 60000);
  }

  /**
   * Handles date change events and updates the schedule time in the form.
   *
   * @param event The date change event.
   * @returns {void}
   */
  onDateChange(event: any): void {
    this.rideDetailsForm.patchValue({
      scheduleTime: event.selectedDates[0]
    });
  }

  /**
   * Adds a new stop to the stops array in the ride details form.
   * Limits the number of stops to a maximum of 5.
   *
   * @param {void}
   * @returns {void}
   */
  addStop(): void {
    this.onStepChangeToSecond();
    if (this.addressControls["pickup"].invalid) {
      this.addressControls["pickup"].markAsTouched();
      return;
    }

    if (this.stops.length > 0 && this.stops.invalid) {
      this.stops.markAllAsTouched();
      return;
    }

    if (this.stops.length < this.vehicleTypesData.citySetting.maxStopLimit) {
      const newStop = this.fb.group({
        address: ["", [Validators.required]],
        stopAddress: [""]
      });

      // Add validator for unique stop addres

      this.stops.push(newStop);
    }
  }

  /**
   * Removes a stop from the stops array in the ride details form.
   *
   * @param index The index of the stop to remove.
   * @returns {void}
   */
  removeStop(index: number): void {
    this.stops.removeAt(index);
    this.removeMarker.emit(index);
    this.onStepChangeToSecond();
  }

  /**
   * Performs a customer search based on the phone number entered in the form.
   * Updates the userForm with the retrieved customer details if found.
   *
   * @param {void}
   * @returns {void}
   */
  onCustomerSearch(): void {
    if (!this.customerDetails && this.controls["phone"].invalid) {
      this.controls["phone"].markAsTouched();
      return;
    }

    if (this.customerDetails && this.controls["phone"].value.length === 0) {
      return;
    }

    const params = {
      searchText: this.userForm.value.phone
    };
    this.bookingService.getCustomerDetails(params).subscribe((response: any) => {
      if (response?.customer) {
        const customer = response.customer;
        const name = [customer.firstName, customer.lastName].filter((part: string) => !!String(part || "").trim()).join(" ").trim();
        this.userForm.patchValue({
          ...customer,
          firstName: name || customer.firstName || ""
        });
        this.customerDetails = customer;
      } else {
        this.customerDetails = null;
        this.userForm.patchValue({
          firstName: "",
          email: ""
        });
      }
    });
  }

  /**
   * Handles phone number changes and resets customer details if necessary.
   *
   * @param {void}
   * @returns {void}
   */
  onPhoneChange(): void {
    if (this.customerDetails && this.customerDetails.phone !== this.userForm.value.phone) {
      this.customerDetails = null;
      this.userForm.patchValue({
        firstName: "",
        email: ""
      });
    }
  }

  /**
   * Handles country code changes and shows the country code modal.
   *
   * @param {void}
   * @returns {void}
   */
  onCountryChange(): void {
    this.countryCodeModal.showModal();
  }

  /**
   * Checks if the country code is disabled.
   *
   * @param {void}
   * @returns {boolean} True if the country code is disabled, false otherwise.
   */
  isCountryCodeDisabled(): boolean {
    return this.countryCodeModal.countryArray[0]?.phoneCodes.length <= 1;
  }

  /**
   * Changes the phone code in the userForm based on the selected country.
   *
   * @param event The event containing the selected phone code.
   * @returns {void}
   */
  changePhoneCode(event: any): void {
    this.userForm.patchValue({
      countryPhoneCode: event
    });
    this.selectedCountry = this.countryList.filter((x: any) => x.phoneCodes.includes(event));
    if (this.helper.dispatcherDetails.setting?.mapType === this.helper.MapType.GOOGLE) {
      this.addressAutoComplete();
    } else if (this.helper.dispatcherDetails.setting?.mapType === this.helper.MapType.MAP_BOX) {
      this.addressAutoCompleteMapbox();
    }
  }

  /**
   * Handles the click event for selecting a dispatcher booking type.
   * Updates the rideDetailsForm with the selected bookingType and fetches updated vehicle list.
   *
   * @param type The dispatcher booking type object clicked.
   * @returns {void}
   */
  typeClick(type: any): void {
    if ((!this.oneScreen && this.currentStep !== 2) || !type) {
      return;
    }

    this.DispatcherBookingType.forEach((x: any) => {
      x.isActive = x.key === type.key;
    });

    this.selectedBookingType = type;

    this.rideDetailsForm.patchValue({ bookingType: this.helper.BookingType[type.key] });

    if (this.vehicleTypesData) {
      this.vehicleTypeList = [];
      this.vehicleCapacityList = [];
      this.rideDetailsForm.patchValue({ vehicleType: null, when: null, scheduleDate: "", scheduleTime: "" });
      this.selectedRentalPackage = null;
      this.selectedVehicleType = null;
      this.vehicleListByType();
      this.onVehicleTypeFilter();
      // const allTypeVehicles = this.vehicleTypeList;
      // allTypeVehicles.forEach((vehicle: any) => {
      //   this.vehicleCapacityList.push(vehicle.vehicleTypeDetail.passengerCapacity);
      // });
      // this.vehicleCapacityList = Array.from(new Set(this.vehicleCapacityList)).sort((a, b) => a - b);
    }
    this.validatorUpdateOnStop();

    if (this.rideDetailsForm.value.bookingType === this.helper.BookingType.SHARE) {
      const stopsArray = this.stops;
      // Loop through all stops in reverse order
      for (let i = stopsArray.length - 1; i >= 0; i--) {
        this.removeMarker.emit(i); // Emit the removeMarker event for each stop in decreasing order
      }

      this.stops.clear();
    }

    this.isMultipleLocations = this.vehicleTypesData.citySetting.businessSetting[type.key].includes("MULTIPLE_LOCATION");
    this.isAllowOutsideBoundry = this.vehicleTypesData.citySetting.businessSetting[type.key].includes("OUTSIDE_BOUNDARY");
    this.bookingSetting = this.getBookingSettings(type.key);
  }

  /**
   * Retrieves the booking settings for the specified booking type.
   *
   * @param bookingType The booking type.
   * @returns { { [key: string]: boolean } } The booking settings.
   */
  getBookingSettings(bookingType: any): { [key: string]: boolean } {
    const availableSettings = this.vehicleTypesData.citySetting.bookingSetting[bookingType] || [];
    const settingsObject: { [key: string]: boolean } = {};

    // Iterate over all possible settings and set true/false based on the available settings
    for (const setting of Object.values(this.helper.BookingSetting)) {
      if (typeof setting === "string") {
        settingsObject[setting] = availableSettings.includes(setting);
      }
    }

    return settingsObject;
  }

  /**
   * Handles input change events for address search fields based on the map type.
   * Trims the input value and, if non-empty, processes it according to the map type.
   * For Google Maps, the input value and element ID are pushed to an RxJS subject.
   * For MapBox, a custom debounce method is invoked with the input value and element ID.
   *
   * @param event The input change event containing the target input element and value.
   */
  onInputChange(event: Event): void {
    const mapType = this.helper.dispatcherDetails.setting.mapType;
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value.trim();

    if (!inputValue) return;

    if (mapType === this.helper.MapType.GOOGLE) {
      // Google: Push to inputSubject; RxJS pipeline handles debounce
      this.inputSubject.next({ value: inputValue, elem: inputElement.id });
    } else if (mapType === this.helper.MapType.MAP_BOX) {
      // Mapbox: Use custom debounce method
      this.debouncedOnSearchMapbox(inputElement.id, inputValue);
    }
  }

  // Creating the debounced version of the onSearchMapbox method
  debouncedOnSearchMapbox = this.helper.debounce((elementId: string, value: string) => {
    this.inputSubject.next({ value, elem: elementId });
  }, 500);

  /**
   * Resets the predictions arrays.
   *
   * @param {void}
   * @returns {void}
   */
  resetPrediction(): void {
    if (this.isGoogle) {
      this.predictions = [];
      this.destinationPredictions = [];
      this.stopPrediction = [];
    } else if (this.helper.mapTypeMapBox()) {
      this.mapBoxSuggestions = [];
      this.mapBoxSuggestionsForDestination = [];
      this.mapBoxSuggestionsForStop = [];
    }
  }

  // Method to be called on input event
  onSearchMapbox(event: any): void {
    const query = event.target.value.trim();
    const code: string = this.selectedCountry[0].code ?? "";
    this.mapBoxService.search(query, code).subscribe((response: any) => {
      this.mapBoxSuggestions = response.features;
    });
  }

  /**
   * Handles address auto-completion based on user input.
   * Sets component restrictions based on the selected country.
   * Processes input predictions using debounced inputSubject events.
   *
   * @param {void}
   * @returns {void}
   */
  addressAutoComplete(): void {
    const params = this.selectedCountry[0].code2 ? { region: this.selectedCountry[0].code2 } : {};
    if (this.inputSubscription) {
      this.inputSubscription.unsubscribe();
    }

    const processPredictions = async (input: any): Promise<Observable<any>> => {
      this.predictions = [];
      this.autoComplateElement = input.elem;
      return await this.googleMapService.getPlacePredictions(input.value, params);
    };

    const handlePredictions = (predictions: any): void => {
      const match = this.autoComplateElement.match(/^(\D+)(\d+)$/);
      if (match) {
        const [, address, num] = match;
        this.autoComplateElement = address;
        this.addedStopNumber = num;
      }

      switch (this.autoComplateElement) {
        case this.helper.AddressType.PICKUP:
          this.predictions = predictions;
          break;
        case this.helper.AddressType.STOP:
          this.stopPrediction = predictions;
          break;
        default:
          this.destinationPredictions = predictions;
          break;
      }
    };

    this.inputSubscription = this.inputSubject.pipe(debounceTime(500), distinctUntilChanged(), switchMap(processPredictions)).subscribe(handlePredictions);
  }

  /**
   * Handles address auto-completion using Mapbox based on user input.
   * Applies country filtering and processes debounced input events.
   *
   * @returns {void}
   */
  addressAutoCompleteMapbox(): void {
    if (this.inputSubscription) {
      this.inputSubscription.unsubscribe();
    }

    const processPredictions = (input: any): Observable<any> => {
      this.predictions = [];
      this.autoComplateElement = input.elem;
      const query = input.value.trim();

      if (!query) {
        return of([]);
      }

      const countryCode = this.selectedCountry[0].code2;

      return this.mapBoxService.search(query, countryCode);
    };

    const handlePredictions = (res: any): void => {
      const match = this.autoComplateElement.match(/^(\D+)(\d+)$/);
      if (match) {
        const [, address, num] = match;
        this.autoComplateElement = address;
        this.addedStopNumber = num;
      }

      const features = res?.features || [];

      switch (this.autoComplateElement) {
        case this.helper.AddressType.PICKUP:
          this.mapBoxSuggestions = features;
          break;
        case this.helper.AddressType.STOP:
          this.mapBoxSuggestionsForStop = features;
          break;
        default:
          this.mapBoxSuggestionsForDestination = features;
          break;
      }
    };

    this.inputSubscription = this.inputSubject.pipe(debounceTime(500), distinctUntilChanged(), switchMap(processPredictions)).subscribe({
      next: handlePredictions,
      error: (err) => console.error("[Mapbox] Error during autocomplete:", err),
      // eslint-disable-next-line no-console
      complete: () => console.log("[Mapbox] Autocomplete stream completed")
    });
  }

  /**
   * Checks if the specified index is selected.
   *
   * @param index The index to check.
   * @returns {boolean} True if the index is selected, false otherwise.
   */
  isSelected(index: number): boolean {
    return this.selectedMapBoxSearchIndex === index;
  }

  /**
   * Handles the selection of a place prediction from the autocomplete list.
   * Sets the selected address, resets predictions, proceeds to the next step, and fetches place details.
   *
   * @param prediction The selected prediction object from the autocomplete list.
   * @returns {void}
   */
  async onPredictionSelect(prediction: any): Promise<void> {
    this.selectedSearchAddress = prediction.description;
    this.resetPrediction();
    this.onStepChangeToSecond();
    const place = await this.googleMapService.fetchFields(prediction);
    this.selectedPlace = place;
    this.selectedPlace.placeId = prediction.place_id;
    this.onPlaceSelected(this.selectedPlace);
  }

  /**
   * Handles the selection of a MapBox suggestion.
   *
   * @param suggestion The selected suggestion object from MapBox.
   * @returns {void}
   */
  onSelect(suggestion: any): void {
    this.selectedSearchAddress = suggestion.place_name;
    this.resetPrediction();
    this.onStepChangeToSecond();
    this.mapBoxService.reverseGeocode({ latitude: suggestion.center[1], longitude: suggestion.center[0] }).then((res: any) => {
      if (res && res.features && res.features.length) {
        const primaryFeature = res.features[0]; // Most relevant result

        this.selectedPlace = primaryFeature;
        this.selectedPlace.placeId = primaryFeature.id;
        this.onPlaceSelected(this.selectedPlace);
      }
    });
    this.mapBoxSuggestions = [];
    // eslint-disable-next-line no-console
  }

  /**
   * Handles the selected place details from the autocomplete input and processes the address accordingly.
   * Sets the appropriate form values, emits events to set markers, and clears dependent form fields.
   *
   * @param place The selected place object containing details like address, coordinates, and more.
   * @returns {void}
   */
  onPlaceSelected(place: any): void {
    let lat, lng, address;
    if (this.isGoogle) {
      lat = place.geometry.location.lat();
      lng = place.geometry.location.lng();
      address = this._buildAddressObject(place, lat, lng, this.isGoogle);
    } else if (this.helper.mapTypeMapBox()) {
      lat = place.geometry.coordinates[1];
      lng = place.geometry.coordinates[0];
      address = this._buildAddressObject(place, lat, lng, this.isGoogle);
    }
    address.address = this.selectedSearchAddress;

    switch (this.autoComplateElement) {
      case this.helper.AddressType.PICKUP:
        this._patchAddressAndEmitMarker({ pickup: this.selectedSearchAddress, pickupAddress: address }, address, this.helper.AddressType.PICKUP);
        this.getVehicleTypeList();
        break;

      case this.helper.AddressType.STOP:
        this.patchStop(this.addedStopNumber, address);
        this._emitStopMarker(address);
        break;

      case this.helper.AddressType.DESTINATION:
        this._patchAddressAndEmitMarker({ dropOff: this.selectedSearchAddress, dropOffAddress: address }, address, this.helper.AddressType.DESTINATION);
        if (this.rideDetailsForm.value.pickup && this.rideDetailsForm.value.dropOff) {
          this.getVehicleTypeList();
        }
        break;

      default:
        break;
    }

    if (this.rideDetailsForm.value.pickup && this.rideDetailsForm.value.dropOff) {
      this.rideDetailsForm.patchValue({ vehicleType: null, rentalPackage: null });
      this.selectedRentalPackage = null;
    }
  }

  /**
   * Builds an address object from the provided place details.
   * Extracts and returns relevant details such as address, latitude, longitude, country, etc.
   *
   * @param place The selected place object containing address details.
   * @param lat The latitude of the selected place.
   * @param lng The longitude of the selected place.
   * @returns {any} The constructed address object with additional details.
   */
  private _buildAddressObject(place: any, lat: number, lng: number, isGoogle: boolean = false): any {
    return buildBookRideAddress(place, lat, lng, this.selectedCountry?.[0], isGoogle);
  }

  /**
   * Patches the form with the specified address value and emits an event to set a marker on the map.
   *
   * @param patchValue The value to patch into the form (pickup or drop-off address).
   * @param address The address object containing details like coordinates, type, etc.
   * @param addressType The type of address (pickup or drop-off).
   * @returns {void}
   */
  private _patchAddressAndEmitMarker(patchValue: any, address: any, addressType: string): void {
    this.rideDetailsForm.patchValue(patchValue);
    address.type = addressType;
    this.setMarker.emit(address);
  }

  /**
   * Emits an event to set a marker for a stop address on the map.
   *
   * @param address The address object for the stop containing details like coordinates and stop index.
   * @returns {void}
   */
  private _emitStopMarker(address: any): void {
    address.type = this.helper.AddressType.STOP;
    address.stopIndex = Number(this.addedStopNumber);
    this.setMarker.emit(address);
  }

  /**
   * Patches the stop address in the form at the specified index.
   *
   * @param index The index of the stop to patch.
   * @param address The address object to patch.
   * @returns {void}
   */
  patchStop(index: number, address: any): void {
    this.stops.at(index).patchValue({ address: this.selectedSearchAddress, stopAddress: address });
  }

  /**
   * Retrieves the list of countries from the server and populates the countryArray.
   *
   * @param {void}
   * @returns {void}
   */
  getCountryList(): void {
    const parameters: any = {}; // Define parameters for the request

    this.countryService.getCountryList(parameters).subscribe((response: any) => {
      // Make a request to fetch the list of countries
      this.countryList = response.countries; // Populate the countriesList array with the fetched countries
    });
  }

  /**
   * Clears the specified address fields (pickup or drop-off) in the ride details form.
   * Emits an event to remove the marker from the map and resets relevant form values.
   *
   * @param type The type of address to clear (pickup or drop-off).
   * @returns {void}
   */
  clearAddress(type: any): void {
    const clearAddressFields = (fieldType: string, addressType: string): void => {
      this.rideDetailsForm.patchValue({
        [fieldType]: "",
        [`${fieldType}Address`]: ""
      });
      const address = { type: addressType };
      this.setMarker.emit(address);
      this.onStepChangeToSecond();
    };

    if (type === this.helper.AddressType.PICKUP) {
      clearAddressFields("pickup", this.helper.AddressType.PICKUP);
    } else {
      clearAddressFields("dropOff", this.helper.AddressType.DESTINATION);
    }
  }

  /**
   * Handles step change to the second step in the multi-step form process.
   *
   * @param {void}
   * @returns {void}
   */
  onStepChangeToSecond(): void {
    if (this.currentStep === 3 || this.currentStep === 4) {
      this.currentStep = 2;
      this.validatorUpdateOnStop();
    }
  }

  /**
   * Retrieves the list of vehicle types based on the current ride details.
   * Cleans up the pickup and drop-off address fields and makes a service call to get the available vehicle types for the ride.
   *
   * @param {void}
   * @returns {void}
   */
  getVehicleTypeList(updatedCharges: any[] = [], vehicleTypeId: string = ""): void {
    // Check if the form value exists
    if (!this.rideDetailsForm?.value) return;
    const stopRows = this.rideDetailsForm.get("stops") as FormArray | null;
    if (!stopRows?.controls) return;

    // Initialize stopAddresses array
    this.stopAddresses = stopRows.value
      // eslint-disable-next-line consistent-return
      .map((value: any) => {
        const { stopAddress } = value;
        // Remove unnecessary properties from stopAddress
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { type, stopIndex, ...cleanedAddress } = stopAddress;
        if (cleanedAddress.placeId) {
          return cleanedAddress;
        }
        // Implicitly return undefined for cases where placeId doesn't exist
      })
      .filter((address: any) => address !== undefined); // Remove undefined values

    // Clean up pickup and drop-off addresses
    const { pickupAddress, dropOffAddress } = this.rideDetailsForm.value;
    const cleanedPickupAddress = { ...pickupAddress, type: undefined };
    const cleanedDropOffAddress = { ...dropOffAddress, type: undefined };
    // Patch the cleaned addresses back into the form
    this.rideDetailsForm.patchValue({
      pickupAddress: cleanedPickupAddress,
      dropOffAddress: dropOffAddress ? cleanedDropOffAddress : ""
    });

    // Create JSON object for the request
    const json: any = {
      countryCode: this.selectedCountry[0].code2,
      totalTime: this.totalRideTime,
      totalDistance: this.totalRideDistance,
      pickupAddress: cleanedPickupAddress,
      destinationAddresses: dropOffAddress ? [cleanedDropOffAddress] : []
    };
    if (updatedCharges) {
      json.updatedCharges = updatedCharges;
    }

    if (vehicleTypeId) {
      json.vehicleTypeId = vehicleTypeId;
      json.priceMode = this.rideDetailsForm.value.bookingType;
    }

    if (this.stopAddresses.length > 0) {
      json.destinationAddresses = [...this.stopAddresses, ...json.destinationAddresses];
    }
    json.businessType = this.selectedBusinessType;
    json.bookingTime = this.bookingTime ? new Date(this.bookingTime).getTime() : Date.now();
    // Price for the rider being booked, so the auto-promo is checked against THEIR per-user / new-user
    // rules. createRide sends that promo on, and re-quotes if the rider changed after this request.
    json.customerId = this.customerDetails?._id || undefined;
    this.quotedForCustomerId = this.customerDetails?._id || "";

    // Call the booking service to get the vehicle type list
    // eslint-disable-next-line sonarjs/cognitive-complexity
    this.bookingService.getVehicleTypeList(json).subscribe((response) => {
      if (response) {
        if (vehicleTypeId) {
          const bookingType = this.rideDetailsForm.value.bookingType;
          // Define a configuration object for each booking type
          const typeConfig: any = {
            [this.helper.BookingType.NORMAL]: {
              list: response.normalList
            },
            [this.helper.BookingType.SHARE]: {
              list: response.shareList
            },
            [this.helper.BookingType.RENTAL]: {
              list: response.rentalList
            },
            [this.helper.BookingType.TAXI_METER]: {
              list: response.taxiMeterBookingList
            },
            [this.helper.BookingType.TOWING]: {
              list: response.towingBookingList
            }
          };
          updatedCharges.forEach((charge: any) => {
            const index = typeConfig[bookingType].list[0].priceDetail.charges.findIndex((x: any) => x.title === charge.title);
            if (index !== -1) {
              typeConfig[bookingType].list[0].priceDetail.charges[index].actualPrice = charge.actualPrice;
              typeConfig[bookingType].list[0].priceDetail.charges[index].multiplier = charge.multiplier;
            } else {
              const additionalPriceIndex = typeConfig[bookingType].list[0].priceDetail.additionalPrices.findIndex((x: any) => x.title === charge.title);
              if (additionalPriceIndex !== -1) {
                typeConfig[bookingType].list[0].priceDetail.additionalPrices[additionalPriceIndex].actualPrice = charge.actualPrice;
                typeConfig[bookingType].list[0].priceDetail.additionalPrices[additionalPriceIndex].multiplier = charge.multiplier;
              }
            }
          });
          const vehicleTypeIndex = this.vehicleTypeList.findIndex((x: any) => x.vehicleTypeId === vehicleTypeId);
          if (vehicleTypeIndex !== -1) {
            const updatedList = [...this.vehicleTypeList]; // create shallow copy
            updatedList[vehicleTypeIndex] = typeConfig[bookingType].list[0];
            this.vehicleTypeList = updatedList;
            this.onTypeChange(typeConfig[bookingType].list[0]);
          }
        } else {
          this.vehicleTypesData = response;
          this.countrySetting = this.vehicleTypesData.countrySetting;
          this.isTypeDetailsCalled = true;
          this.fetchDistance = this.vehicleTypesData.distance;
          this.fetchTime = this.vehicleTypesData.time;
          this.fetchdirectionPath = this.vehicleTypesData.directionPath;
          this.typeListFilter();
          this.vehicleListByType();
          if (this.currentStep === 3) {
            this.getNearestProvider();
          }

          // Automatically select the first booking type if not already set

          if (!this.rideDetailsForm.value.bookingType) {
            if (localStorage.getItem("taxiBookingType")) {
              const bookingTypeKey = this.helper.BookingType[Number(localStorage.getItem("taxiBookingType"))];
              const selectedBookingType = this.DispatcherBookingType.find((x: any) => x.key === bookingTypeKey);
              if (selectedBookingType) {
                this.selectedBookingType = selectedBookingType;
                this.typeClick(selectedBookingType);
              }
            } else {
              this.selectedBookingType = this.DispatcherBookingType[0];
              this.typeClick(this.DispatcherBookingType[0]);
            }
          }
        }
        this._cdr.detectChanges();
      } else {
        this.vehicleTypesData = null;
        this.vehicleTypeList = [];
        this.DispatcherBookingType = [];
        this.isAllowOutsideBoundry = false;
        this.isMultipleLocations = false;
        this.fetchDistance = 0;
        this.fetchTime = 0;
        this.fetchdirectionPath = null;
        this.rideDetailsForm.patchValue({
          bookingType: null
        });

        this._cdr.detectChanges();
      }
    });
  }

  /**
   * Retrieves the date and time value based on the schedule date and time.
   *
   * @param scheduleDate The schedule date.
   * @param scheduleTime The schedule time.
   * @returns {Date} The combined date and time value.
   */
  getDateTimeValue(scheduleDate: any, scheduleTime: any): Date {
    const [hours, minutes] = scheduleTime.split(":").map(Number);
    scheduleDate.setHours(hours, minutes);
    return new Date(scheduleDate.toISOString());
  }

  /**
   * Updates the vehicle type list and maximum booking days based on the selected booking type and scheduling type.
   *
   * @param {void}
   * @returns {void}
   */
  vehicleListByType(): void {
    const bookingType = this.rideDetailsForm.value.bookingType && this.DispatcherBookingType?.length > 0 ? this.rideDetailsForm.value.bookingType : null;
    // Define a configuration object for each booking type
    const typeConfig: any = {
      [this.helper.BookingType.NORMAL]: {
        list: this.vehicleTypesData.normalList,
        days: this.vehicleTypesData.citySetting.driverSetting.NORMAL.SCHEDULE.maxBookingDays,
        bufferTime: this.vehicleTypesData.citySetting.driverSetting.NORMAL.SCHEDULE.bufferTime
      },
      [this.helper.BookingType.SHARE]: {
        list: this.vehicleTypesData.shareList,
        days: this.vehicleTypesData.citySetting.driverSetting.SHARE.SCHEDULE.maxBookingDays,
        bufferTime: this.vehicleTypesData.citySetting.driverSetting.NORMAL.SCHEDULE.bufferTime
      },
      [this.helper.BookingType.RENTAL]: {
        list: this.vehicleTypesData.rentalList,
        days: this.vehicleTypesData.citySetting.driverSetting.RENTAL.SCHEDULE.maxBookingDays,
        bufferTime: this.vehicleTypesData.citySetting.driverSetting.NORMAL.SCHEDULE.bufferTime
      },
      [this.helper.BookingType.TAXI_METER]: {
        list: this.vehicleTypesData.taxiMeterBookingList,
        days: this.vehicleTypesData.citySetting.driverSetting.TAXI_METER.SCHEDULE.maxBookingDays,
        bufferTime: this.vehicleTypesData.citySetting.driverSetting.NORMAL.SCHEDULE.bufferTime
      },
      [this.helper.BookingType.TOWING]: {
        list: this.vehicleTypesData.towingBookingList,
        days: this.vehicleTypesData.citySetting.driverSetting.TOWING.SCHEDULE.maxBookingDays,
        bufferTime: this.vehicleTypesData.citySetting.driverSetting.NORMAL.SCHEDULE.bufferTime
      }
    };
    // Check if the configuration for the booking type exists and the list is not empty
    if (bookingType && typeConfig[bookingType] && typeConfig[bookingType].list.length > 0) {
      this.vehicleTypeList = typeConfig[bookingType].list;
      this.onGetVehicleTypeList.emit(this.vehicleTypeList);

      // Update daysFromToday if the booking type is 'SCHEDULE'
      this.daysFromToday = typeConfig[bookingType].days;
      this.bufferTime = typeConfig[bookingType].bufferTime;
    } else {
      this.vehicleTypeList = [];
    }
  }

  /**
   * Filters and updates the dispatcher booking type list based on the available vehicle type lists.
   *
   * @param {void}
   * @returns {void}
   */
  typeListFilter(): void {
    const features = this.vehicleTypesData.citySetting.businessSetting;
    const typeLists = [
      { list: this.vehicleTypesData.normalList, type: this.helper.DispatcherBookingType[0], key: "NORMAL" },
      { list: this.vehicleTypesData.shareList, type: this.helper.DispatcherBookingType[1], key: "SHARE" },
      { list: this.vehicleTypesData.rentalList, type: this.helper.DispatcherBookingType[2], key: "RENTAL" },
      { list: this.vehicleTypesData.taxiMeterBookingList, type: this.helper.DispatcherBookingType[3], key: "TAXI_METER" },
      { list: this.vehicleTypesData.towingBookingList, type: this.helper.DispatcherBookingType[4], key: "TOWING" }
    ];

    if (this.vehicleTypesData) {
      typeLists.forEach((typeList) => {
        if (typeList.list?.length > 0 && features[typeList.key]?.includes("IS_BUSINESS") && !this.DispatcherBookingType.includes(typeList.type)) {
          this.DispatcherBookingType.push(typeList.type);
        } else if (typeList.list?.length === 0 || !features[typeList.key]?.includes("IS_BUSINESS")) {
          this.DispatcherBookingType = this.DispatcherBookingType.filter((x: any) => x !== typeList.type);
        }
      });
    }
  }

  /**
   * Handles vehicle type change and updates the selected vehicle type.
   *
   * @param vehicleType The selected vehicle type.
   * @returns {void}
   */
  onTypeChange(vehicleType: any): void {
    this.onSelectVehicleType.emit(vehicleType);
    this.currentStep = 3;
    this.selectedVehicleType = null;
    setTimeout(() => {
      this.selectedVehicleType = vehicleType;
      this.totalEstimatedFare = vehicleType.priceDetail.total;
      // this.rideDetailsForm.patchValue({ vehicleType: vehicleType.vehicleTypeId });

      if (this.rideDetailsForm.value.bookingType === this.helper.BookingType.RENTAL) {
        this.rideDetailsForm.patchValue({ rentalPackage: null });
        this.selectedRentalPackage = null;
      }

      this.isSurgePriceAvailable = false;
      this.surgeUnit = null;
      this.selectedVehicleType?.priceDetail?.charges?.forEach((charge: any) => {
        if (charge.title === this.helper.PriceParamEnum.surgePrice && charge.unit > 1) {
          this.isSurgePriceAvailable = true;
          this.surgeUnit = charge.unit;
        }
      });

      this.manageSelectedVehicleAccessibility();
    }, 200);

    this._cdr.detectChanges();
  }

  /**
   * Filters and updates the dispatcher booking type time list based on the selected booking type and available business settings.
   *
   * @param {void}
   * @returns {void}
   */
  onVehicleTypeFilter(): void {
    const bookingType = this.rideDetailsForm.value.bookingType;

    // Mapping numeric booking type values to string keys
    const bookingTypeMap: any = {
      1: "NORMAL",
      2: "SHARE",
      3: "RENTAL",
      101: "TAXI_METER",
      102: "TOWING"
    };

    const businessSettings = this.vehicleTypesData.citySetting.businessSetting;

    const dispatcherTimeTypes: any = {
      NOW: this.helper.DispatcherBookingTypeTime[0],
      SCHEDULE: this.helper.DispatcherBookingTypeTime[1]
    };

    const bookingTypeKey = bookingTypeMap[bookingType];

    // Clear the current dispatcher booking type time list
    this.DispatcherBookingTypeTime = [];

    if (businessSettings[bookingTypeKey]) {
      Object.keys(dispatcherTimeTypes).forEach((key) => {
        if (businessSettings[bookingTypeKey].includes(key) && !this.DispatcherBookingTypeTime.includes(dispatcherTimeTypes[key])) {
          this.DispatcherBookingTypeTime.push(dispatcherTimeTypes[key]);
        }
      });
    }

    if (this.currentStep === 3 && this.DispatcherBookingTypeTime.length === 0) {
      this.rideDetailsForm.get("when")?.setValidators([Validators.required]);
      this.rideDetailsForm.get("when")?.updateValueAndValidity();
    }
    this.rideDetailsForm.patchValue({
      when: this.DispatcherBookingTypeTime[0].key
    });
  }

  /**
   * Retrieves the nearest provider based on the current ride details.
   *
   * @param {void}
   * @returns {void}
   */
  getNearestProvider(): void {
    const params: any = {
      cityId: this.vehicleTypesData.citySetting?.cityId,
      pickupAddress: { latitude: this.rideDetailsForm.value.pickupAddress.latitude, longitude: this.rideDetailsForm.value.pickupAddress.longitude },
      destinationAddress: this.rideDetailsForm.value.dropOffAddress?.latitude
        ? { latitude: this.rideDetailsForm.value.dropOffAddress.latitude, longitude: this.rideDetailsForm.value.dropOffAddress.longitude }
        : undefined,
      isShowErrorToast: false,
      isOffline: true,
      isNowBooking: this.rideDetailsForm.value.when === this.helper.BookingType[this.helper.BookingType.SCHEDULE] ? false : true,
      businessType: this.selectedBusinessType
    };

    if (this.selectedVehicleType?.vehicleTypeId) {
      params["vehicleTypeId"] = this.selectedVehicleType.vehicleTypeId;
    }
    this.bookingService.getNearestDriver(params).subscribe((response: any) => {
      this.uniqueDrivers = [];
      this.nearestProvider = response.drivers;
      if (this.nearestProvider?.length > 0) {
        this.handleDriverDataWithDistanceMatrix(this.rideDetailsForm.value.pickupAddress);
        if (this.bookingSetting.ShowNearestDriver) {
          this.setNearestDriver.emit(this.nearestProvider);
        }
      }
    });
  }

  /**
   * Retrieves the get Agencies based on the current ride details.
   *
   * @param {void}
   * @returns {void}
   */
  getAgencies(): void {
    const params: any = { cityId: this.vehicleTypesData.citySetting?.cityId };
    this.commonService.getAgencies(params).subscribe((response: any) => {
      if (response?.agencies?.length > 0) {
        this.agencies = response.agencies;
      }
    });
  }

  /**
   * Handles the fix fare process based on the selected booking type and surge price availability.
   *
   * @param {void}
   * @returns {void}
   */
  onFixFare(): void {
    const updatedCharges = [
      ...this.selectedVehicleType.priceDetail.charges
        .filter((x: any) => x.multiplier !== undefined && x.multiplier !== null && x.multiplier !== 1)
        .map((x: any) => {
          return {
            title: x.chargeId ? x.chargeId : x.title,
            multiplier: x.multiplier,
            actualPrice: x.actualPrice,
            price: x.price,
            driverProfit: x.driverProfit
          };
        }),

      ...this.selectedVehicleType.priceDetail.additionalPrices
        .filter((x: any) => x.multiplier !== undefined && x.multiplier !== null && x.multiplier !== 1)
        .map((x: any) => {
          return {
            title: x.chargeId ? x.chargeId : x.title,
            multiplier: x.multiplier,
            actualPrice: x.actualPrice,
            price: x.price,
            driverProfit: x.driverProfit
          };
        })
    ];

    if (this.isManually === this.helper.bookingDriverAssignEnum.MANUALLY && !this.driverId) {
      return;
    }
    // Get the array of settings for the selected booking type
    const bookingTypeMap: any = {
      1: "NORMAL",
      2: "SHARE",
      3: "RENTAL",
      101: "TAXI_METER",
      102: "TOWING"
    };

    const selectedBookingType = bookingTypeMap[this.rideDetailsForm.value.bookingType];

    const fixFareSettingsArray = this.vehicleTypesData.citySetting.businessSetting[selectedBookingType];

    // Check if "FIX_FARE" is in the array
    this.isFixFareAvailable = fixFareSettingsArray.includes(this.helper.BookingType[this.helper.BookingType.FIX_FARE]);
    this.isAlwaysFixFare = fixFareSettingsArray.includes(this.helper.BookingType[this.helper.BookingType.IS_ALWAYS_FIX_FARE]);

    // if (this.isSurgePriceAvailable) {
    //   this.surgePrice.openModal(this.surgeUnit);
    // } else

    if (this.isFixFareAvailable && !this.isAlwaysFixFare && updatedCharges.length === 0) {
      this.fixFareModal.openModal();
    } else {
      // const isFixFare = (this.isFixFareAvailable && this.isAlwaysFixFare) || updatedCharges.length > 0;
      // this.createRide(isFixFare, updatedCharges);
      const isFixFare = (this.isFixFareAvailable && this.isAlwaysFixFare) || updatedCharges.length > 0;
      if (this.selectedBusinessType === BusinessType.TOWING && this.questionsList.length > 0) {
        this.pendingIsFixFare = isFixFare;
        this.pendingUpdatedCharges = updatedCharges;
        this.currentQuestionIndex = 0;
        this.resetQuestionAnswers();
        this.isShowQuestionsModal = true;
      } else {
        this.createRide(isFixFare, updatedCharges);
      }
    }
  }

  /**
   * Creates a ride booking based on the current form values and selected options.
   *
   * @param isFixFare Indicates whether the booking is a fix fare.
   * @returns {void}
   */
  /**
   * 3.8.0 requires customerDetail.firstName and accepts lastName as an optional string.
   * The form keeps one Name field; the first word is firstName and the rest is lastName.
   */
  private customerDetailFromName(): { phone: string; countryPhoneCode: string; firstName: string; lastName: string; email: string } {
    const value = this.userForm.value;
    const parts = String(value.firstName || "")
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    return {
      phone: value.phone,
      countryPhoneCode: value.countryPhoneCode,
      firstName: parts[0] || "",
      lastName: parts.slice(1).join(" "),
      email: value.email || ""
    };
  }

  createRide(isFixFare: any, updatedCharges: any[]): void {
    this.isAgencyError = false;
    // The shown fare (and its auto-promo) was priced for a different rider than the one now selected —
    // re-quote instead of booking a promo that may not apply to them, or a fare they were never shown.
    if ((this.customerDetails?._id || "") !== this.quotedForCustomerId) {
      this.toasterService.showNotification("error", "Customer changed — fares have been refreshed. Please review and book again.");
      this.getVehicleTypeList();
      return;
    }
    if (this.isManually === this.helper.bookingDriverAssignEnum.MANUALLY && !this.driverId) {
      return;
    }

    if (this.selectedPaymentMethod === PaymentMode.Wallet && !this.selectedAgencyId && this.bookingSetting.ShowAgencySelection) {
      this.isAgencyError = true;
      return;
    }

    const bookingTime = this.bookingTime ? new Date(this.bookingTime).getTime() : Date.now();
    const manualDriver = this.isManually === this.helper.bookingDriverAssignEnum.MANUALLY;
    const params = buildCreateRidePayload({
      estimatedDistance: this.totalRideDistance,
      driverId: manualDriver ? this.driverId : "",
      bookingType: this.rideDetailsForm.value.bookingType,
      directionPath: this.directionPath,
      paymentMode: this.selectedPaymentMethod,
      destinationAddresses: [...this.stopAddresses, this.rideDetailsForm.value.dropOffAddress],
      bookingTime,
      vehiclePriceId: this.rideDetailsForm.value.bookingType === this.helper.BookingType.RENTAL ? this.rideDetailsForm.value.rentalPackage : this.selectedVehicleType?._id,
      estimatedTime: this.totalRideTime,
      isFixFare,
      pickupAddress: this.rideDetailsForm.value.pickupAddress,
      updatedCharges,
      businessType: this.selectedBusinessType,
      agencyId: this.selectedAgencyId || undefined,
      customerId: this.customerDetails?._id,
      customerDetail: this.customerDetails ? undefined : this.customerDetailFromName(),
      customerNote: this.customerNote || undefined,
      speakingLanguages: this.getSpeakingLanguages(),
      accessibilityIds: this.getAccessibilityIds(),
      preferredGender: this.appliedfilterDetails?.selectedGender,
      promoCodeId:
        (this.rideDetailsForm.value.bookingType === this.helper.BookingType.RENTAL
          ? this.selectedRentalPackage?.priceDetail?.promoDetail?.id
          : this.selectedVehicleType?.priceDetail?.promoDetail?.id) || undefined
    });

    this.bookingService.createRideBooking(params).subscribe((response: any) => {
      if (response?.isPaymentRequired) {
        this.toasterService.showNotification("error", this.helper.translateService.instant("label-title.payment-required"));
        return;
      }
      if (!response || response.failed) {
        const serverMessage = response?.message ? String(response.message) : "";
        this.toasterService.showNotification("error", serverMessage || this.helper.translateService.instant("label-title.something-went-wrong"));
        return;
      }
      if (response) {
        if (this.selectedBusinessType === BusinessType.TOWING && this.questionsList.length > 0) {
          this.submitBookingQuestions(response?.id);
        }

        this.completeBooking.emit();
        this.isFixFareAvailable = false;
        this.surgeUnit = null;
        this.isSurgePriceAvailable = false;
        this.appliedfilterDetails = null;
        this.DispatcherBookingType.forEach((element: any) => {
          element.isActive = false;
        });
      }
    });
  }

  /**
   * Handles driver assignment change and updates the assignment method.
   *
   * @param assignManually Indicates whether to assign the driver manually.
   * @param event The event object.
   * @returns {void}
   */
  onDriverAssignChange(assignManually: number, event: Event): void {
    if ((assignManually && !this.isManually) || (!assignManually && this.isManually)) {
      this.isManually = assignManually;
    } else {
      // Prevent the checkbox from being unchecked if the condition is not met
      event.preventDefault();
    }
  }

  /**
   * Converts the date and time strings to milliseconds.
   *
   * @param dateString The date string.
   * @param timeString The time string.
   * @returns {number} The combined date and time in milliseconds.
   */
  convertToMilliseconds(dateString: any, timeString: any): number {
    // Parse the date string
    const date = new Date(dateString);

    // Parse the time string
    const [hours, minutes] = timeString.split(":").map(Number);

    // Combine the parsed date and time
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);

    // Convert the combined datetime to milliseconds
    return date.getTime();
  }

  /**
   * Opens the fare estimate modal for the selected vehicle type or rental package.
   *
   * @param {void}
   * @returns {void}
   */
  viewEstimate(): void {
    if (this.addressControls["vehicleType"].invalid) {
      this.addressControls["vehicleType"].markAsTouched();
      return;
    }

    let index;
    if (this.rideDetailsForm.value.bookingType !== this.helper.BookingType.RENTAL) {
      index = this.vehicleTypeList.findIndex((x: any) => x.vehicleTypeId === this.rideDetailsForm.value.vehicleType);
    } else {
      index = this.selectedVehicleType.packageList.findIndex((x: any) => x._id === this.rideDetailsForm.value.rentalPackage);
    }

    if (index !== -1) {
      if (this.rideDetailsForm.value.bookingType !== this.helper.BookingType.RENTAL) {
        this.viewFareEstimate.showModal(
          { ...this.vehicleTypeList[index] },
          this.vehicleTypesData.countrySetting,
          {
            totalDistance: this.totalRideDistance,
            totalTime: this.totalRideTime
          },
          this.bookingSetting.EditFareEstimate
        );
      } else {
        this.viewFareEstimate.showModal(
          { ...this.selectedVehicleType.packageList[index] },
          this.vehicleTypesData.countrySetting,
          {
            totalDistance: this.totalRideDistance,
            totalTime: this.totalRideTime
          },
          this.bookingSetting.EditFareEstimate
        );
      }
    }
  }

  /**
   * Retrieves the selected speaking languages from the applied filter details.
   *
   * @param {void}
   * @returns {any[]} The array of selected speaking languages.
   */
  getSpeakingLanguages(): any[] {
    if (this.appliedfilterDetails?.selectedSpeakingLanguage) {
      return [this.appliedfilterDetails.selectedSpeakingLanguage];
    }
    return [];
  }

  /**
   * Handles the event when surge price is applied.
   * Opens the fix fare modal if necessary or creates a ride booking.
   *
   * @param event The event object.
   * @returns {void}
   */
  onSurgePriceApplied(event: any): void {
    if (event && !this.isAlwaysFixFare) {
      this.fixFareModal.openModal();
    } else if (event) {
      const isFixFare = this.isFixFareAvailable && this.isAlwaysFixFare;
      this.createRide(isFixFare, []);
    }
  }

  /**
   * Handles package change and updates the selected rental package.
   *
   * @param packageId The ID of the selected package.
   * @returns {void}
   */
  onPackageChange(packageId: any): void {
    const packageIndex = this.selectedVehicleType.packageList.findIndex((x: any) => x._id === packageId);
    if (packageIndex !== -1) {
      this.selectedRentalPackage = this.selectedVehicleType.packageList[packageIndex];
      this.isSurgePriceAvailable = false;
      this.surgeUnit = null;
      this.selectedRentalPackage?.priceDetail?.charges?.forEach((charge: any) => {
        if (charge.title === this.helper.PriceParamEnum.surgePrice && charge.unit > 1) {
          this.isSurgePriceAvailable = true;
          this.surgeUnit = charge.unit;
        }
      });
      this.manageSelectedVehicleAccessibility();
    }
  }

  /**
   * Handles driver data with distance matrix and updates the nearest provider.
   *
   * @param pickupAddress The pickup address object containing latitude and longitude.
   * @returns {void}
   */
  private async handleDriverDataWithDistanceMatrix(pickupAddress: { latitude: number; longitude: number }): Promise<void> {
    const origin = {
      latLng: {
        latitude: pickupAddress.latitude,
        longitude: pickupAddress.longitude
      }
    };

    const uniqueDriversMap = new Map();

    this.uniqueDrivers = this.nearestProvider.filter((driver: any) => {
      if (!uniqueDriversMap.has(driver.vehicleTypeId)) {
        uniqueDriversMap.set(driver.vehicleTypeId, true);
        return true;
      }
      return false;
    });

    const destinations: any[] = this.uniqueDrivers.map((drivers: any) => {
      return {
        waypoint: {
          location: {
            latLng: {
              latitude: drivers.location.coordinates[1],
              longitude: drivers.location.coordinates[0]
            }
          }
        }
      };
    });
    const distanceResponse = await this.googleMapService.getDistances(origin, destinations);
    this.updateDriverMap(distanceResponse);
  }

  /**
   * Updates the driver map with distance and duration information.
   *
   * @param distanceResponse The response object containing distance information.
   * @returns {void}
   */
  private updateDriverMap(distanceResponse: any): void {
    if (!distanceResponse || distanceResponse?.length === 0) return;

    const distances = distanceResponse;
    this.vehicleTypeList.forEach((vehicle: any, vehicleIndex: number) => {
      // Find a matching driver in uniqueDrivers based on vehicleTypeId
      let matchedDriverIndex = this.uniqueDrivers.findIndex((driver: any) => driver.vehicleTypeId === vehicle.vehicleTypeId);

      // If no direct match, try each fallback in order
      if (matchedDriverIndex === -1 && vehicle.vehicleTypeDetail?.fallbackTypes) {
        for (const fb of vehicle.vehicleTypeDetail.fallbackTypes) {
          const idx = this.uniqueDrivers.findIndex((driver: any) => driver.vehicleTypeId === fb.vehicleTypeId);
          if (idx !== -1) {
            matchedDriverIndex = idx;
            break;
          }
        }
      }

      if (matchedDriverIndex !== -1) {
        let distanceInKm = distances[matchedDriverIndex]?.distanceMeters || 0;
        let durationInMinutes = parseInt(distances[matchedDriverIndex]?.duration, 10) || 0;

        distanceInKm = Math.round(distanceInKm / 1000); // Convert meters to kilometers
        durationInMinutes = Math.round(durationInMinutes / 60); // Convert seconds to minutes

        // Handle zero duration properly
        if (durationInMinutes < 1) {
          durationInMinutes = 1;
        }

        this.vehicleTypeList[vehicleIndex]["distance"] = distanceInKm;
        this.vehicleTypeList[vehicleIndex]["duration"] = durationInMinutes;
      }
    });
  }

  /**
   * Calculates the duration and ETA (Estimated Time of Arrival) based on the provided duration.
   *
   * @param duration The duration in minutes.
   * @returns {string} The formatted duration and ETA string.
   */
  calculateDurationAndEta(duration: string): string {
    if (duration) {
      const eta = this.calculateETA(Number(duration)); // Calculate ETA
      return `${duration} min | ETA ${eta}`;
    }
    return this.helper.translateService.instant("label-title.no-driver-found");
  }

  /**
   * Calculates the Estimated Time of Arrival (ETA) based on the provided duration in minutes.
   *
   * @param {number} durationInMinutes - The duration in minutes.
   * @returns {string} - The formatted ETA string in the format "hh:mm AM/PM".
   */
  private calculateETA(durationInMinutes: number): string {
    const now = new Date();
    now.setMinutes(now.getMinutes() + durationInMinutes);

    // Format hours and minutes
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  }

  /**
   * Opens the booking vehicle filter modal with the applied filter details and settings.
   *
   * @param {void}
   * @returns {void}
   */
  openBookingVehicleFilterModal(): void {
    this.bookingVehicleFilterModal.openModal({
      appliedfilterDetails: this.appliedfilterDetails,
      countrySetting: this.vehicleTypesData.countrySetting,
      accessibilityList: this.vehicleTypesData.accessibilities,
      vehicleCapacityList: this.vehicleCapacityList,
      allowNoOfSeatSelection: this.bookingSetting.AllowNoOfSeatSelection
    });
  }

  /**
   * Handles the application of filters and updates the vehicle type list accordingly.
   *
   * @param appliedfilterDetails The applied filter details.
   * @returns {void}
   */
  onApplyFilter(appliedfilterDetails: any): void {
    this.appliedfilterDetails = appliedfilterDetails;
    this.rideDetailsForm.patchValue({ vehicleType: null, rentalPackage: null });
    this.selectedRentalPackage = null;
    this.setupBookingTypeVehicleList();
  }

  /**
   * Sets up the vehicle type list based on the selected booking type and applied filters.
   *
   * @param {void}
   * @returns {void}
   */
  private setupBookingTypeVehicleList(): void {
    this.vehicleTypeList = [];
    switch (this.rideDetailsForm.value.bookingType) {
      case this.helper.PriceMode.NORMAL:
        this.filterVehicleTypeList(this.vehicleTypesData.normalList);
        break;
      case this.helper.PriceMode.SHARE:
        this.filterVehicleTypeList(this.vehicleTypesData.shareList);
        break;
      case this.helper.PriceMode.RENTAL:
        this.filterVehicleTypeList(this.vehicleTypesData.rentalList);
        break;
      case this.helper.PriceMode.TAXI_METER:
        this.filterVehicleTypeList(this.vehicleTypesData.taxiMeterBookingList);
        break;
      case this.helper.PriceMode.TOWING:
        this.filterVehicleTypeList(this.vehicleTypesData.towingBookingList);
        break;
      default:
        break;
    }
  }

  /**
   * Filters the vehicle type list based on accessibility and seat capacity.
   *
   * @param list The list of vehicle types to filter.
   * @returns {void}
   */
  filterVehicleTypeList(list: any): void {
    const arrFilteredAccessibility = this.appliedfilterDetails?.accessibilityIds ?? [];

    // Filter based on accessibility
    this.vehicleTypeList = arrFilteredAccessibility.length > 0 ? this.filterVehiclesByAccessibility(list, arrFilteredAccessibility) : [...list];
    this.onGetVehicleTypeList.emit(this.vehicleTypeList);

    // Filter based on seat capacity
    if (this.vehicleTypeList.length > 0 && this.appliedfilterDetails?.selectedCapacity) {
      this.vehicleTypeList = this.filterVehiclesBySeatCapacity(this.vehicleTypeList);
    }
  }

  /**
   * Filters the vehicle type list based on accessibility.
   *
   * @param list The list of vehicle types to filter.
   * @param arrFilteredAccessibility The array of filtered accessibility IDs.
   * @returns {any[]} The filtered vehicle type list.
   */
  private filterVehiclesByAccessibility(list: any[], arrFilteredAccessibility: string[]): any[] {
    return list.filter((vehicle) =>
      this.rideDetailsForm.value.bookingType === this.helper.PriceMode.RENTAL
        ? this.isRentalVehicleAccessible(vehicle, arrFilteredAccessibility)
        : this.isVehicleAccessible(vehicle, arrFilteredAccessibility)
    );
  }

  /**
   * Checks if a rental vehicle is accessible based on the filtered accessibility IDs.
   *
   * @param vehicle The rental vehicle object.
   * @param arrFilteredAccessibility The array of filtered accessibility IDs.
   * @returns {boolean} True if the rental vehicle is accessible, false otherwise.
   */
  private isRentalVehicleAccessible(vehicle: any, arrFilteredAccessibility: string[]): boolean {
    return (vehicle.packageList || []).some((rentalPackage: any) => {
      const vehicleAccessibility = this.getVehicleAccessibility(rentalPackage.priceDetail);
      return arrFilteredAccessibility.every((id) => vehicleAccessibility.includes(id));
    });
  }

  /**
   * Checks if a vehicle is accessible based on the filtered accessibility IDs.
   *
   * @param vehicle The vehicle object.
   * @param arrFilteredAccessibility The array of filtered accessibility IDs.
   * @returns {boolean} True if the vehicle is accessible, false otherwise.
   */
  private isVehicleAccessible(vehicle: any, arrFilteredAccessibility: string[]): boolean {
    const vehicleAccessibility = this.getVehicleAccessibility(vehicle.priceDetail);
    return arrFilteredAccessibility.every((id) => vehicleAccessibility.includes(id));
  }

  /**
   * Retrieves the accessibility prices for a vehicle.
   *
   * @param priceDetail The price detail object of the vehicle.
   * @returns {string[]} The array of accessibility IDs.
   */
  private getVehicleAccessibility(priceDetail: any): string[] {
    return (priceDetail?.accessibilityPrices || []).map((price: any) => price.chargeId || "");
  }

  /**
   * Filters the vehicle type list based on seat capacity.
   *
   * @param list The list of vehicle types to filter.
   * @returns {any[]} The filtered vehicle type list.
   */
  private filterVehiclesBySeatCapacity(list: any[]): any[] {
    return list.filter((vehicle) => this.appliedfilterDetails.selectedCapacity <= (vehicle.vehicleTypeDetail?.passengerCapacity || 0));
  }

  /**
   * Handles accessibility change events and updates the accessibility status.
   *
   * @param event The change event object.
   * @param accessibility The accessibility object.
   * @returns {void}
   */
  onChangeAccessibility(event: any, accessibility: any): void {
    accessibility.isChecked = event.target.checked;
    this.updateTotalAccessibilityPrices();
  }

  /**
   * Manages the selected vehicle accessibility based on the booking type and selected vehicle or rental package.
   *
   * @param {void}
   * @returns {void}
   */
  manageSelectedVehicleAccessibility(): void {
    let accessibilityPrices: any[] = [];
    if (this.rideDetailsForm.value.bookingType === this.helper.BookingType.RENTAL) {
      accessibilityPrices = this.selectedRentalPackage?.priceDetail?.accessibilityPrices || [];
    } else if (this.selectedVehicleType?.priceDetail?.accessibilityPrices?.length > 0) {
      accessibilityPrices = this.selectedVehicleType?.priceDetail?.accessibilityPrices || [];
    }

    accessibilityPrices.forEach((accessibility: any) => {
      const acc = this.vehicleTypesData.accessibilities?.find((x: any) => x._id === accessibility.chargeId);
      accessibility.name = acc?.accessibility;
      accessibility.isChecked = false;
    });
    this.updateTotalAccessibilityPrices();
  }

  /**
   * Retrieves the selected accessibility IDs from the selected vehicle or rental package.
   *
   * @param {void}
   * @returns {any[]} The array of selected accessibility IDs.
   */
  getAccessibilityIds(): any[] {
    const accessibilityIds: any[] = [];

    if (this.rideDetailsForm.value.bookingType === this.helper.BookingType.RENTAL) {
      this.selectedRentalPackage?.priceDetail?.accessibilityPrices.forEach((acc: any) => {
        if (acc.isChecked) {
          accessibilityIds.push(acc.chargeId);
        }
      });
      return accessibilityIds;
    }

    this.selectedVehicleType?.priceDetail?.accessibilityPrices?.forEach((acc: any) => {
      if (acc.isChecked) {
        accessibilityIds.push(acc.chargeId);
      }
    });
    return accessibilityIds;
  }

  /**
   * Updates the total accessibility prices by summing the price of each checked accessibility option.
   *
   * @returns {void}
   */
  updateTotalAccessibilityPrices(): void {
    let total = 0;

    // Determine which accessibilityPrices array to use based on the booking type.
    if (this.rideDetailsForm.value.bookingType === this.helper.BookingType.RENTAL) {
      const prices = this.selectedRentalPackage?.priceDetail?.accessibilityPrices || [];
      prices.forEach((item: any) => {
        if (item.isChecked && item.price) {
          total += item.price;
        }
      });
    } else {
      const prices = this.selectedVehicleType?.priceDetail?.accessibilityPrices || [];
      prices.forEach((item: any) => {
        if (item.isChecked && item.price) {
          total += item.price;
        }
      });
    }

    this.totalAccessibilityPrices = total;
  }

  calculateTotal(charges: any[]): void {
    this.getVehicleTypeList(charges, this.selectedVehicleType.vehicleTypeId);
  }

  /**
   * Opens the date-time picker modal.
   */
  // eslint-disable-next-line complexity
  openDateTimePickerModal(): void {
    const canSchedule: boolean =
      this.vehicleTypesData?.citySetting?.businessSetting[this.selectedBookingType.key]?.includes(this.helper.BookingType[this.helper.BookingType.SCHEDULE].toString()) ?? false;
    if (canSchedule) {
      this.dateTimePickerModal.openModal({
        bufferTime: this.vehicleTypesData?.citySetting?.driverSetting[this.selectedBookingType.key][this.helper.BookingType[this.helper.BookingType.SCHEDULE]]?.bufferTime,
        maxBookingDays: this.vehicleTypesData?.citySetting?.driverSetting[this.selectedBookingType.key][this.helper.BookingType[this.helper.BookingType.SCHEDULE]]?.maxBookingDays,
        selectionType:
          this.vehicleTypesData?.citySetting?.driverSetting[this.selectedBookingType.key][this.helper.BookingType[this.helper.BookingType.SCHEDULE]]?.scheduleTimeSelectionType,
        slotIntervalInMinutes:
          this.vehicleTypesData?.citySetting?.driverSetting[this.selectedBookingType.key][this.helper.BookingType[this.helper.BookingType.SCHEDULE]]?.slotIntervalInMinutes
      });
    }
  }

  /**
   * Removes the schedule.
   */
  removeSchedule(): void {
    this.bookingTime = null;
    const whenInitValue = this.setWhenBookingString();
    this.rideDetailsForm.get("when")?.setValue(whenInitValue);
  }

  /**
   * Sets the booking time string.
   * @returns The booking time string.
   */
  setWhenBookingString(): string {
    const key =
      this.isShowCreateBusinessDetails(this.helper.BookingType.SCHEDULE) && !this.isShowCreateBusinessDetails(this.helper.BookingType.NOW)
        ? this.helper.BookingType.SCHEDULE
        : this.helper.BookingType.NOW;
    const str = this.helper.DispatcherBookingTypeTime.find((item) => item.key === BookingType[key])?.string ?? this.helper.DispatcherBookingTypeTime[0].string;
    return this.helper.translateService.instant(str);
  }

  /**
   * Checks if a specific business detail should be shown.
   * @param detailType The detail type.
   * @returns True if the detail should be shown, false otherwise.
   */
  isShowCreateBusinessDetails(detailType: number): boolean {
    return this.selectedBookingType && this.vehicleTypesData?.citySetting?.businessSetting[this.selectedBookingType.key]?.includes(this.helper.BookingType[detailType].toString())
      ? true
      : false;
  }

  /**
   * Handles date selection events.
   * @param event The selected date.
   */
  onDateSelected(event: any): void {
    this.bookingTime = event;
    const dateString = `${this.datePipe.transform(event, "dd MMMM yyyy")}-${this.datePipe.transform(event, "hh:mm a")}`;

    const text = `${this.helper.translateService.instant("label-title.schedule")}: ${dateString}`;
    this.rideDetailsForm.get("when")?.setValue(text);
  }




  getQuestionsList(): void {
    this.bookingService.getQuestionsList({ type: this.helper.UserType.CUSTOMER })
      .subscribe((response: any) => {
        if (response) {
          this.questionsList = response
            .filter((question: any) =>
              question.isActive &&
              question.countryId === this.helper.dispatcherDetails.entity.countryId
            )
            .map((question: any) => {
              question.cuurentLangQuestionText = typeof question.questionText === 'object'
                ? (question.questionText[this.helper.cuurentLang] ?? question.questionText['en'] ?? Object.values(question.questionText)[0] ?? '')
                : question.questionText;
              if (question.questionType === 'MULTI_OPTION') {
                question.selectedOptions = [];
              } else if (question.questionType === 'IMAGE') {
                question.selectedImages = [];
              } else {
                question.answer = '';
              }
              return question;
            });
        }
      });
  }

  onBookRideWithQuestions(): void {
    if (!this.selectedPaymentMethod) {
      this.toasterService.showNotification('error', this.helper.translateService.instant('validation-title.please-select-payment-method'));
      return;
    }

    if (this.selectedBusinessType === BusinessType.TOWING && this.questionsList.length > 0) {
      this.currentQuestionIndex = 0;
      this.resetQuestionAnswers();
      this.isShowQuestionsModal = true;
      this.pendingIsFixFare = false;
      this.pendingUpdatedCharges = [];
    } else {
      this.onFixFare();
    }
  }

  resetQuestionAnswers(): void {
    this.questionsList.forEach((q: any) => {
      if (q.questionType === 'MULTI_OPTION') {
        q.selectedOptions = [];
      } else if (q.questionType === 'IMAGE') {
        q.selectedImages = [];
      } else {
        q.answer = '';
      }
    });
  }

  onQuestionContinue(): void {
    const currentQ = this.questionsList[this.currentQuestionIndex];

    if (!this.isCurrentQuestionAnswered(currentQ)) {
      this.toasterService.showNotification('error', this.helper.translateService.instant('validation-title.please-answer-the-question'));
      return;
    }

    if (this.currentQuestionIndex < this.questionsList.length - 1) {
      this.currentQuestionIndex++;
    } else {
      this.isShowQuestionsModal = false;
      this.createRide(this.pendingIsFixFare, this.pendingUpdatedCharges);
    }
  }

  isCurrentQuestionAnswered(question: any): boolean {
    if (!question) return true;
    switch (question.questionType) {
      case 'SINGLE_OPTION':
        return question.answer !== '' && question.answer !== undefined;
      case 'MULTI_OPTION':
        return question.selectedOptions?.length > 0;
      case 'FREE_TEXT':
        return question.answer?.trim().length > 0;
      case 'NUMBER':
        return question.answer !== '' && question.answer !== undefined;
      case 'IMAGE':
        if (question.selectedImages?.length === 0) {
          this.toasterService.showNotification('error', this.helper.translateService.instant('validation-title.please-select-image'));
          return false;
        }
        if (question.selectedImages?.length > 5) {
          this.toasterService.showNotification('error', this.helper.translateService.instant('validation-title.max-5-images-allowed'));
          return false;
        }
        return true;
      default:
        return true;
    }
  }

  toggleMultiOption(question: any, optionIndex: number): void {
    if (!question.selectedOptions) {
      question.selectedOptions = [];
    }
    const idx = question.selectedOptions.indexOf(String(optionIndex));
    if (idx > -1) {
      question.selectedOptions.splice(idx, 1);
    } else {
      question.selectedOptions.push(String(optionIndex));
    }
  }

  onQuestionImageSelected(event: any, question: any): void {
    const files: FileList = event.target.files;
    if (files) {
      const currentCount = question.selectedImages?.length || 0;
      const incoming = Array.from(files);

      if (currentCount + incoming.length > 5) {
        this.toasterService.showNotification(
          'error',
          this.helper.translateService.instant('validation-title.max-5-images-allowed')
        );
        event.target.value = '';
        return;
      }

      incoming.forEach((file: File) => {
        question.selectedImages.push(file);
      });
      event.target.value = '';
    }
  }

  removeQuestionImage(question: any, index: number): void {
    question.selectedImages.splice(index, 1);
  }

  submitBookingQuestions(bookingId: string): void {
    const formData = new FormData();

    this.questionsList.forEach((question: any, qIndex: number) => {
      formData.append(`questions[${qIndex}][questionId]`, question._id);
      formData.append(`questions[${qIndex}][questionType]`, question.questionType);

      const questionText = typeof question.questionText === 'object'
        ? (question.questionText[this.helper.cuurentLang] ?? question.questionText['en'] ?? Object.values(question.questionText)[0] ?? '')
        : (question.questionText ?? '');
      formData.append(`questions[${qIndex}][questionText]`, questionText);

      if (question.questionType === 'SINGLE_OPTION') {
        const selectedIndex = Number(question.answer);
        const selectedValue = Array.isArray(question.options) ? (question.options[selectedIndex].label[this.helper.cuurentLang] ?? question.options[selectedIndex].label['en'] ?? '') : '';
        formData.append(`questions[${qIndex}][answer]`, selectedValue);

      } else if (question.questionType === 'MULTI_OPTION') {
        (question.selectedOptions as string[]).forEach((optIdx: string) => {
          const selectedValue = Array.isArray(question.options) ? (question.options[Number(optIdx)].label[this.helper.cuurentLang] ?? question.options[Number(optIdx)].label['en'] ?? '') : '';
          formData.append(`questions[${qIndex}][answer][]`, selectedValue);
        });

      } else if (question.questionType === 'IMAGE') {
        (question.selectedImages as File[]).forEach((file: File) => {
          formData.append('question', file);
        });

      } else {
        // FREE_TEXT, NUMBER
        formData.append(`questions[${qIndex}][answer]`, String(question.answer ?? ''));
      }
    });

    formData.append('isShowErrorToast', 'false');

    this.bookingService.submitBookingQuestions(bookingId, formData).subscribe({
      next: () => undefined, // SECURITY: no response payload in the console
      error: (err) => console.error('Failed to submit questions', err)
    });
  }

  getObjectUrl(file: File): string {
    return URL.createObjectURL(file);
  }



  /**
   * Unsubscribes from the updateObservable when the component is destroyed.
   *
   * @returns {void}
   */
  ngOnDestroy(): void {
    this.updateObservable.unsubscribe();
  }
}
